var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    {
      attrs: {
        name: "custom-classes-transition",
        "enter-active-class": "animated slideInRight",
        "leave-active-class": "animated slideOutRight",
      },
    },
    [
      _vm.show
        ? _c(
            "nav",
            {
              staticClass: "fixed-right min-vh-100",
              attrs: {
                id: "application-changelog-summary",
                "aria-label": "nav",
              },
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "click-outside",
                      rawName: "v-click-outside",
                      value: _vm.handleClickOutside,
                      expression: "handleClickOutside",
                    },
                  ],
                  staticClass: "card mb-0 h-100",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "card-header p-4 d-flex justify-content-between",
                    },
                    [
                      _c("h5", { staticClass: "bold mb-0 mr-4" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t(
                                "application-changelog.applicationChangelog"
                              )
                            ) +
                            "\n        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        [
                          _c("icon", {
                            staticClass: "grey-text clickable",
                            attrs: { name: "times" },
                            on: { click: _vm.handleClose },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticStyle: { "overflow-y": "auto" } }, [
                    _vm.loading
                      ? _c(
                          "div",
                          [
                            _c("skeleton"),
                            _vm._v(" "),
                            _c("skeleton"),
                            _vm._v(" "),
                            _c("skeleton"),
                            _vm._v(" "),
                            _c("skeleton"),
                            _vm._v(" "),
                            _c("skeleton"),
                          ],
                          1
                        )
                      : _c(
                          "div",
                          _vm._l(_vm.changelog, function (item, index) {
                            return _c("changelog-item", {
                              key: index,
                              attrs: {
                                changelog: item,
                                "agent-username": _vm.agentUsername,
                              },
                            })
                          }),
                          1
                        ),
                  ]),
                ]
              ),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }